import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Form
} from "reactstrap";
import { DocenteService } from "service/DocenteService";
import FSelect from "components/Select/FSelect";

const ModalDocente = ({ isOpen, toggle, selectedDocente, onSave }) => {
  const [docente, setDocente] = useState({
    documentoidentidad: "",
    nombres: "",
    apellidopaterno: "",
    apellidomaterno: "",
    especialidad: "",
    estado: "1"
  });
  const [errors, setErrors] = useState({});

  const docenteService = new DocenteService();

  useEffect(() => {
    if (isOpen) {
      setErrors({});
      if (selectedDocente) {
        setDocente(selectedDocente);
      } else {
        setDocente({
          documentoidentidad: "",
          nombres: "",
          apellidopaterno: "",
          apellidomaterno: "",
          especialidad: "",
          estado: "1"
        });
      }
    }
  }, [isOpen, selectedDocente]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDocente(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: null }));
  };

  const validate = () => {
    const e = {};
    if (!docente.documentoidentidad || docente.documentoidentidad.length !== 8)
      e.documentoidentidad = "El DNI debe tener exactamente 8 dígitos";
    if (!docente.nombres?.trim())
      e.nombres = "Los nombres son obligatorios";
    if (!docente.apellidopaterno?.trim())
      e.apellidopaterno = "El apellido paterno es obligatorio";
    if (!docente.apellidomaterno?.trim())
      e.apellidomaterno = "El apellido materno es obligatorio";
    if (!docente.especialidad)
      e.especialidad = "La especialidad es obligatoria";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSave = async () => {
    if (!validate()) return;
    try {
      let res;
      if (docente._id) {
        res = await docenteService.updateDocente(docente);
      } else {
        // Al igual que con alumnos, creamos el objeto usuario por defecto
        const nuevoDocente = {
          ...docente,
          usuario: {
            nombreusuario: docente.documentoidentidad,
            contrasena: (docente.nombres.charAt(0) + docente.apellidopaterno.charAt(0) + docente.documentoidentidad).toLowerCase(),
            rol: 'Docente'
          }
        };
        res = await docenteService.addDocente(nuevoDocente);
      }

      if (res?.confirmation === "success") {
        alert(docente._id ? "Docente actualizado" : "Docente registrado");
        onSave();
        toggle();
      } else {
        alert(res?.message || "Error al procesar la solicitud");
      }
    } catch (error) {
      console.error("Error guardando docente:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md" backdrop="static">
      <ModalHeader toggle={toggle}>
        {docente._id ? "Editar Docente" : "Registrar Docente"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>DNI *</Label>
                <Input
                  name="documentoidentidad"
                  value={docente.documentoidentidad}
                  onChange={handleChange}
                  maxLength="8"
                  invalid={!!errors.documentoidentidad}
                  disabled={!!docente._id}
                />
                {errors.documentoidentidad && <small className="text-danger">{errors.documentoidentidad}</small>}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Especialidad *</Label>
                <FSelect
                  name="especialidad"
                  value={docente.especialidad}
                  onChange={handleChange}
                  options={[
                    { value: "Ciencias", label: "Ciencias" },
                    { value: "Letras", label: "Letras" },
                  ]}
                  placeholder="Seleccione Especialidad"
                />
                {errors.especialidad && <small className="text-danger">{errors.especialidad}</small>}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <FormGroup>
                <Label>Nombres *</Label>
                <Input
                  name="nombres"
                  value={docente.nombres}
                  onChange={handleChange}
                  invalid={!!errors.nombres}
                />
                {errors.nombres && <small className="text-danger">{errors.nombres}</small>}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>Apellido Paterno *</Label>
                <Input
                  name="apellidopaterno"
                  value={docente.apellidopaterno}
                  onChange={handleChange}
                  invalid={!!errors.apellidopaterno}
                />
                {errors.apellidopaterno && <small className="text-danger">{errors.apellidopaterno}</small>}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>Apellido Materno *</Label>
                <Input
                  name="apellidomaterno"
                  value={docente.apellidomaterno}
                  onChange={handleChange}
                  invalid={!!errors.apellidomaterno}
                />
                {errors.apellidomaterno && <small className="text-danger">{errors.apellidomaterno}</small>}
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="primary" onClick={handleSave}>Guardar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalDocente;
